import { render } from "./ElDropdownRelationships.vue?vue&type=template&id=514d585a&ts=true"
import script from "./ElDropdownRelationships.vue?vue&type=script&lang=ts"
export * from "./ElDropdownRelationships.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__